export const SectionIds = {
  PATIENT_CHECK: 'patient_check',
  CONSULT_HISTORY: 'consult_history',
  CONSULT_NOTES: 'consult_notes',
  PRESCRIPTIONS: 'prescriptions',
} as const;
